import { render, staticRenderFns } from "./FoodSharePointBubble.vue?vue&type=template&id=91d392fa&scoped=true"
import script from "./FoodSharePointBubble.vue?vue&type=script&lang=js"
export * from "./FoodSharePointBubble.vue?vue&type=script&lang=js"
import style0 from "./FoodSharePointBubble.vue?vue&type=style&index=0&id=91d392fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d392fa",
  null
  
)

export default component.exports